import { ErrorModal, PageContainer, LoginModal } from "components";
import { variants } from "components/AnimatedRoutes";
import { motion } from "framer-motion";
import {
  AddEditStudentTeacherModal,
  AddEditMayTermModal,
  AddEditPartnerSchoolModal,
  AddEditFacultyModal,
  AddEditHiredPlacementModal,
} from "components/reusables/AddEditModals";
import { UserContext } from "contexts";
import React, { useContext, useState, useEffect } from "react";
import { useAsync } from "react-async";
import { Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { resetToggles } from "components/Navigation";
// import { setTimeout } from "timers";
// import { setTimeout } from "timers-browserify";

import {
  getStudentTeachersAndHiredPlacements,
  loginAsAdmin,
  logout,
  sendPasswordResetEmail,
} from "services";
import "./MapViewAdmin.scss";
// eslint-disable-next-line import/extensions
import { MayTermList } from "../CardLists/MayTermList";
// eslint-disable-next-line import/extensions
import { PartnerSchoolList } from "../CardLists/PartnerSchoolList";
// eslint-disable-next-line import/extensions
import { FacultyList } from "../CardLists/FacultyList";
// eslint-disable-next-line import/extensions
import { StudentTeacherCard } from "../CardLists";
import "bootstrap/dist/css/bootstrap.min.css";
// eslint-disable-next-line import/extensions
import { HiredPlacementList } from "../CardLists/HiredPlacementCardList";

export function MapViewAdmin(): JSX.Element {
  const { data, error } = useAsync({ promiseFn: getStudentTeachersAndHiredPlacements });
  const user = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowingNewTeacherModal, setIsShowingNewTeacherModal] = useState(false);
  const [isShowingNewMayTermModal, setIsShowingNewMayTermModal] = useState(false);
  const [isShowingNewPartnerSchoolModal, setIsShowingNewPartnerSchoolModal] = useState(false);
  const [isShowingNewFacultyModal, setIsShowingNewFacultyModal] = useState(false);
  const [isShowingNewHiredPlacementModal, setIsShowingNewHiredPlacementModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setIsLoading(true);
    /* Adds a little bit of buffer time to check if user exists, so that if the
     * user IS logged in, they don't see the login modal briefly when opening the
     * admin page. */
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  return isLoading ? (
    <div id="loader">
      <PageContainer>
        <Spinner animation="border" />
      </PageContainer>
    </div>
  ) : (
    <motion.div
      variants={variants}
      initial="jobenter"
      animate="jobcenter"
      exit="jobexit"
      transition={{
        x: { bounce: 0, duration: 0.5, type: "spring" },
      }}
    >
      <LoginModal
        isLoggedIn={!!user}
        loginFn={loginAsAdmin}
        title="Admin Login"
        description="Please login using your admin credentials to view this content."
        passwordResetFn={sendPasswordResetEmail}
      />
      <PageContainer>
        <div className="flex-container">
          <div className="go-back">
            <Button
              variant="outline-secondary"
              border-right="right"
              onClick={() => {
                history.push("map");
                resetToggles();
              }}
            >
              Back To Map
            </Button>
          </div>
          <div className="logout">
            <Button
              variant="outline-secondary"
              border-right="right"
              onClick={() => {
                history.push("map");
                resetToggles();
                logout();
              }}
            >
              Log Out
            </Button>
          </div>
        </div>
        <div className="teacher-list">
          <div>
            <div className="text-container">
              <h1>Education Department Members</h1>
              <p>
                Student-Teachers, Recent Alumni, Travel Opportunities, Partner Schools, and Faculty
                from the Hope College Education Department
              </p>
            </div>
            <div className="button-grid-container">
              <Button
                variant="outline-primary"
                onClick={() => setIsShowingNewTeacherModal(true)}
                size="lg"
              >
                <i className="fas fa-plus mr-2" />
                New Student Teacher
              </Button>
              <Button
                variant="outline-primary"
                onClick={() => setIsShowingNewHiredPlacementModal(true)}
                size="lg"
              >
                <i className="fas fa-plus mr-2" />
                New Alumni
              </Button>
              <Button
                variant="outline-primary"
                onClick={() => setIsShowingNewMayTermModal(true)}
                size="lg"
              >
                <i className="fas fa-plus mr-2" />
                New Travel Opportunity
              </Button>

              <Button
                variant="outline-primary"
                onClick={() => setIsShowingNewPartnerSchoolModal(true)}
                size="lg"
              >
                <i className="fas fa-plus mr-2" />
                New Partner School
              </Button>
              <Button
                variant="outline-primary"
                onClick={() => setIsShowingNewFacultyModal(true)}
                size="lg"
              >
                <i className="fas fa-plus mr-2" />
                New Faculty
              </Button>
            </div>
          </div>
          {data &&
            data
              .filter(teacher => teacher.display === true)
              .map(teacher => <StudentTeacherCard key={teacher.id} studentTeacher={teacher} />)}
          <FacultyList />
          <PartnerSchoolList />
          <HiredPlacementList />
          <MayTermList />
        </div>
        <ErrorModal error={error} />
        <AddEditStudentTeacherModal
          show={isShowingNewTeacherModal}
          setShow={setIsShowingNewTeacherModal}
          currentTeacher={undefined}
        />
        <AddEditHiredPlacementModal
          show={isShowingNewHiredPlacementModal}
          setShow={setIsShowingNewHiredPlacementModal}
          currentHiredPlacement={undefined}
        />
        <AddEditFacultyModal
          show={isShowingNewFacultyModal}
          setShow={setIsShowingNewFacultyModal}
          currentFaculty={undefined}
        />
        <AddEditMayTermModal
          show={isShowingNewMayTermModal}
          setShow={setIsShowingNewMayTermModal}
          // onCancel={() => setIsShowingNewMayTermModal(false)}
          currentMayTerm={undefined}
        />
        <AddEditPartnerSchoolModal
          show={isShowingNewPartnerSchoolModal}
          setShow={setIsShowingNewPartnerSchoolModal}
          // onCancel={() => setIsShowingNewPartnerSchoolModal(false)}
          currentPartnerSchool={undefined}
        />
      </PageContainer>
    </motion.div>
  );
}
